import { actionCreator } from 'utils';
import * as StoreTypes from '../types/storeTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    offset: 0,
    limit: 50,
    togglingId: null,
    isSubmitting: false,

    filters: {
        name: '',
        phone: '',
        region: '',
        manager: '',
        type: undefined,
        status: undefined,
        language: undefined,
    },

    edit: {
        loading: false,
        data: null,
        error: false,
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case StoreTypes.LOAD_STORE:
        return Object.assign({}, state, {
            ...state,
            loading: true,
        });

    case actionCreator(StoreTypes.LOAD_STORE, 'err'):
        return Object.assign({}, state, {
            ...state,
            loading: false,
            error: true,
        });

    case actionCreator(StoreTypes.LOAD_STORE, 'res'):
        return Object.assign({}, state, {
            ...state,
            loading: false,
            listing: action.data,
        });

    case StoreTypes.SET_STORE_PAGINATION:
        return Object.assign({}, state, {
            ...state,
            [action.key]: action.pagination,
        });

    case StoreTypes.SET_STORE_FILTERS:
        return Object.assign({}, state, {
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case StoreTypes.RESET_STORE_FILTERS:
        return Object.assign({}, state, {
            ...state,
            filters: initState.filters,
        });

    case StoreTypes.EDIT_STORE:
        return Object.assign({}, state, {
            ...state,
            isSubmitting: true,
        });

    case actionCreator(StoreTypes.EDIT_STORE, 'err'):
        return Object.assign({}, state, {
            ...state,
            isSubmitting: false,
        });

    case actionCreator(StoreTypes.EDIT_STORE, 'res'):
        return Object.assign({}, state, {
            ...state,
            isSubmitting: false,
        });

    case StoreTypes.ADD_STORE:
        return Object.assign({}, state, {
            ...state,
            isSubmitting: true,
        });

    case actionCreator(StoreTypes.ADD_STORE, 'err'):
        return Object.assign({}, state, {
            ...state,
            isSubmitting: false,
        });

    case actionCreator(StoreTypes.ADD_STORE, 'res'):
        return Object.assign({}, state, {
            ...state,
            isSubmitting: false,
        });

    case StoreTypes.LOAD_EDITABLE_STORE:
        return Object.assign({}, state, {
            ...state,
            edit: {
                ...state.edit,
                loading: true,
            },
        });

    case actionCreator(StoreTypes.LOAD_EDITABLE_STORE, 'err'):
        return Object.assign({}, state, {
            ...state,
            edit: {
                ...state.edit,
                loading: false,
                error: true,
            },
        });

    case actionCreator(StoreTypes.LOAD_EDITABLE_STORE, 'res'):
        return Object.assign({}, state, {
            ...state,
            edit: {
                data: action.data,
                loading: false,
                error: false,
            },
        });

    case StoreTypes.TOGGLE_STORE_STATUS:
        return Object.assign({}, state, {
            togglingId: action.id,
        });

    case actionCreator(StoreTypes.TOGGLE_STORE_STATUS, 'err'):
        return Object.assign({}, state, {
            togglingId: null,
        });

    case actionCreator(StoreTypes.TOGGLE_STORE_STATUS, 'res'):
        return Object.assign({}, state, {
            togglingId: null,
        });

    default:
        return state;
    }
}
